//TODO: Clean up dbquery hadnling of "No rows returned"

import * as moment from 'moment';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { DatasourceService } from './datasource.service';

export enum DataSourceStatus {
    Initialized,
    Loading,
    Ready,
    Error,
    InvalidConfig
}

export class Datasource {
    //private _tranType: string = "";
    //private _tranGetUriPath: string;             // e.g. application/{id}
    //private _tranGetDefaultView: string = "Full";
    //private _tranCollectionUriPath: string;      // e.g. application
    //private _tranCollectionDefaultView: string = "Compact";
    //private _tranTemplateUriPath: string;        // e.g. application/template
    //private _tranProcessUriPath: string          // e.g. application
    //private _httpResponseCode = 0;
    //private _refreshTranClass = "Get";

    //TODO had to set everything to public for rework due to datasource service rewrite.   Need to revise this later to use proper scope
    public _tranType: string = '';
    public _tranGetUriPath: string; // e.g. application/{id}
    public _tranGetDefaultView: string = 'Full';
    public _tranCollectionUriPath: string; // e.g. application
    public _tranCollectionDefaultView: string = 'Compact';
    public _tranTemplateUriPath: string; // e.g. application/template
    public _tranTemplateDefaultView: string = 'Full';
    public _tranProcessUriPath: string; // e.g. application
    public _tranPatchUriPath: string; // eg. users/{id}
    public _httpResponseCode = 0;
    public _refreshTranClass = 'Get';
    public _rootNode = 'ConceptOneReply';

    public _criteria: any = {};
    public _datasourceType: string = 'Base';
    public _objectType: string = 'n/a';
    public _apiType = 'XML'; // default is XML, can be changed to JSON for the new API
    public _readonly: boolean = true;
    public _refreshInterval: number = 0;
    public _replyMessage: string = '';
    public _replyCode: number = 0;
    public _intervalID: any = null;
    private _cacheLifeSpan: number = 30; //seconds before datacache expires   -- 0 mean caching is disabled for this datasource
    public _dataLocation: string = ''; //Server, LocalCache, ServerCache (ETM Workspace)   ServerCache not implemented
    public _subscription: Subscription;
    public maxRowLimiter: boolean = false;
    public maxRows: number = 100;
    public lastRequestUrl: string = '';
    public _paused: boolean = false;

    public _status: DataSourceStatus = DataSourceStatus.Initialized; //TODO Define an enumerated type for status  ----
    public statusBS = new BehaviorSubject<DataSourceStatus>(DataSourceStatus.Initialized);

    public showErrors: boolean = true; //if true then datasource will show error message in UI.  If false, error messages will be suppressed.

    //public _callback : any;

    //public _dbqueryNode: string = 'Row'

    public datasourceService: DatasourceService; //added 5/2/17

    public readyTimeStamp: number = null;

    data: any = {}; //TODO:  should model be internal variable with setter/getter?   Name RAW, DATA?

    blobURL: string = null;
    blobSize: number = null;
    blob: Blob = null;

    //processData: any = {};

    public get status$(): Observable<DataSourceStatus> {
        return this.statusBS.asObservable();
    }

    setStatus(value: DataSourceStatus) {
        this._status = value;
        if (value == DataSourceStatus.Ready) {
            this.readyTimeStamp = moment.now();
        } else {
            this.readyTimeStamp = null;
        }
        this.statusBS.next(value);
    }

    get criteria(): any {
        return this._criteria;
    }

    set criteria(value: any) {
        if (value) {
            this._criteria = value;
        }
    }

    get dataLocation(): any {
        return this._dataLocation;
    }

    get cacheLifeSpan(): any {
        return this._cacheLifeSpan;
    }

    set cacheLifeSpan(value: any) {
        // valid values:
        // 0, '0', 'NO-CACHE'                   >>> no caching
        // 1, 2, 30, etc                        >>> seconds before cache expires
        // '30S', '1M', '5M', '1H', '2D', etc.  >>> seconds, minutes, hours, days before cache expires
        if (value) {
            if (!isNaN(+value)) {
                this._cacheLifeSpan = +value;
                return;
            } else {
                let temp: string = value;
                temp = temp.trim().toLowerCase();
                //console.log("temp > " + temp)

                if (temp == '0' || temp == 'no-cache') {
                    this._cacheLifeSpan = 0;
                    return;
                }

                //add code to support  10S , 3M, 3H, 1D   (seconds, miniutes, hours, days)   if suffix left off assume seconds
                let numPart: number = +temp.slice(0, temp.length - 1);
                //console.log("numPart> " + numPart)
                switch (temp.slice(-1).toLocaleUpperCase()) {
                    case 'S':
                        this._cacheLifeSpan = numPart;
                        break;
                    case 'M':
                        this._cacheLifeSpan = numPart * 60;
                        break;
                    case 'H':
                        this._cacheLifeSpan = numPart * 60 * 60;
                        break;
                    case 'D':
                        this._cacheLifeSpan = numPart * 60 * 60 * 24;
                        break;
                }
            }
        }
    }

    //register a callback function
    //set callback(value: any) {
    //     this._callback = value
    //}

    get readonly(): boolean {
        return this._readonly;
    }

    get status(): string {
        return DataSourceStatus[this._status];
    }

    get cacheSignature(): string {
        //sort criteria keys
        let keys: string[] = [];
        var k: string;
        var i: number;
        var keycount: number;

        for (k in this.criteria) {
            if (this.criteria.hasOwnProperty(k)) {
                keys.push(k);
            }
        }

        keys.sort();
        keycount = keys.length;

        // build cache signature  <trantype> + all criteria (name=value) in aplhabetic order separated by semicolons
        // Example: datacache:dbqueryprocess;book_entity_id=currentbook;
        // compare_from_date=2016-06-21;compare_to_date=2016-09-19;from_date=2017-06-21;group_by=lob;
        // procedure_name=epx_recentlybound_graph;team_entity_id=currentuser;team_role_type=currentteamrole;to_date=2017-09-19;top=5;view=full
        let signature = 'datacache:' + this.tranType;

        for (i = 0; i < keycount; i++) {
            k = keys[i];
            if (this.criteria[k] && this.criteria[k] > '') {
                signature = signature + ';' + k + '=' + this.criteria[k];
            }
        }

        return signature.toLocaleLowerCase();
    }

    get objectType(): string {
        return this._objectType;
    }

    get error(): boolean {
        return this._replyCode < 0 ? true : false;
    }

    get tranType(): any {
        //TODO final Name???
        return this._tranType;
    }

    get processDate(): string {
        //TODO final Name???
        let result = '';
        if (this.data) {
            if (this.data[this._rootNode]) {
                if (this.data[this._rootNode]['Process_Date']) {
                    result = this.data[this._rootNode]['Process_Date'];
                }
            }
        }
        return result;
    }

    get replyNode(): any {
        //TODO final Name???
        return this.data[this._rootNode] || {};
    }

    get tranNode(): any {
        //TODO final Name???   Is this the right approach   should we evaluate in a function or set a variable after a retrieve to save reevaluation
        let result = {};
        if (this.data) {
            if (this.data[this._rootNode]) {
                if (this.data[this._rootNode][this._tranType]) {
                    result = this.data[this._rootNode][this._tranType];
                }
            }
        }
        return result;
    }

    get objectNode(): any {
        //TODO final Name???  Is this the right approach   should we evaluate in a function or set a variable after a retrieve to save reevaluation
        let result = {}; //WAS let result = "{}"   PRIOR TO 4/11/2017;
        let mainDataNode = this._objectType;
        //authenticate transaction does not have an object node within in it.   just retrun the transaction node as the object node
        if (this._objectType == 'Authenticate' || this._objectType == 'PasswordProcess') {
            return this.tranNode;
        }
        if (this._objectType == 'DBQuery') {
            mainDataNode = 'Result';
        }
        if (
            this._objectType == 'ContractOption' ||
            this._objectType == 'ContractCondition' ||
            this._objectType == 'ContractAffiliate'
        ) {
            mainDataNode = 'Contract';
        }
        if (this._objectType == 'ProductLineConfig') {
            mainDataNode = 'ProductLine';
        }
        if (this._objectType == 'ObjectConfig') {
            mainDataNode = 'Object';
        }
        if (this._objectType == 'MenuConfig') {
            mainDataNode = 'Menu';
        }
        if (this._objectType == 'PageLayoutConfig') {
            mainDataNode = 'PageLayout';
        }
        if (this._objectType == 'ComponentSettingConfig') {
            mainDataNode = 'ComponentSetting';
        }
        if (this._objectType == 'PageLayoutOrderConfig') {
            mainDataNode = 'PageLayoutOrder';
        }
        if (this._objectType == 'UserDefinedTableConfig') {
            mainDataNode = 'UserDefinedTable';
        }
        if (this._objectType == 'IntegrationServiceConfig') {
            mainDataNode = 'Service';
        }
        if (this._objectType == 'Report') {
            mainDataNode = 'Document';
        }
        if (this._objectType == 'MergeDocument') {
            mainDataNode = 'Document';
        }
        if (this._objectType == 'VINLookup') {
            mainDataNode = 'VIN';
        }
        if (this._objectType == 'AddressLookup') {
            mainDataNode = 'Address';
        }
        if (this._apiType == 'JSON') {
            mainDataNode = 'data';
        }

        if (this.data) {
            if (this.data[this._rootNode]) {
                if (this.data[this._rootNode][this._tranType]) {
                    if (this.data[this._rootNode][this._tranType][mainDataNode]) {
                        result = this.data[this._rootNode][this._tranType][mainDataNode];
                        if (this._objectType == 'DBQuery' && (result == 'No rows returned' || this.error)) {
                            //this is a hack until we clean up dbquery
                            result = { Row: [] };
                        }
                    }
                }
            } else if (this.data[mainDataNode]) {
                result = this.data[mainDataNode];
            }
        }
        return result;
    }

    get objectNodes(): any[] | any {
        //TODO final Name???  Is this the right approach   should we evaluate in a function or set a variable after a retrieve to save reevaluation
        let result = <any>[];
        let mainDataNode = this._objectType;
        if (this._objectType == 'DBQuery') {
            mainDataNode = 'Result';
        }
        if (this._objectType == 'ContractOption') {
            mainDataNode = 'Contract';
        }
        if (this._objectType == 'ProductLineConfig') {
            mainDataNode = 'ProductLine';
        }
        if (this._objectType == 'ObjectConfig') {
            mainDataNode = 'Object';
        }
        if (this._objectType == 'MenuConfig') {
            mainDataNode = 'Menu';
        }
        if (this._objectType == 'PageLayoutConfig') {
            mainDataNode = 'PageLayout';
        }
        if (this._objectType == 'ComponentSettingConfig') {
            mainDataNode = 'ComponentSetting';
        }
        if (this._objectType == 'PageLayoutOrderConfig') {
            mainDataNode = 'PageLayoutOrder';
        }
        if (this._objectType == 'IntegrationServiceConfig') {
            mainDataNode = 'Service';
        }
        if (this._objectType == 'Report') {
            mainDataNode = 'Document';
        }
        if (this._objectType == 'MergeDocument') {
            mainDataNode = 'Document';
        }
        if (this._objectType == 'IntegrationActionConfig') {
            mainDataNode = 'Action';
        }
        if (this._objectType == 'SanctionLookup') {
            mainDataNode = 'Sanction';
        }
        if (this._apiType == 'JSON') {
            mainDataNode = 'data';
        }

        if (this.data) {
            if (this.data[this._rootNode]) {
                if (this.data[this._rootNode][this._tranType]) {
                    if (this.data[this._rootNode][this._tranType][mainDataNode]) {
                        if (this._objectType != 'DBQuery') {
                            result = this.data[this._rootNode][this._tranType][mainDataNode];
                        } else {
                            if (this.data[this._rootNode][this._tranType][mainDataNode].Row) {
                                result = this.data[this._rootNode][this._tranType][mainDataNode].Row;
                            }
                        }
                    }
                }
            } else if (this.data[mainDataNode]) {
                result = this.data[mainDataNode];
            }
        }
        return result;
    }

    get criteriaNode(): any {
        //TODO final Name???  Is this the right approach   should we evaluate in a function or set a variable after a retrieve to save reevaluation
        let result = '{}';
        let CriteriaNode = 'Criteria';

        if (this.data) {
            if (this.data[this._rootNode]) {
                if (this.data[this._rootNode][this._tranType]) {
                    if (this.data[this._rootNode][this._tranType][CriteriaNode]) {
                        result = this.data[this._rootNode][this._tranType][CriteriaNode];
                    }
                }
            }
        }
        return result;
    }

    set objectType(value: string) {
        this._objectType = value;
        this._datasourceType = 'SureMGA';
        switch (
        this._objectType //TODO, put this is a json object and do a lookup instead?
        ) {
            case 'CodeSet':
                this._tranGetUriPath = 'codeset/{Set_Code}';
                this._tranCollectionUriPath = 'codeset';
                break;
            case 'Contract':
                this._tranGetUriPath = 'contract/{Contract_ID}';
                this._tranCollectionUriPath = 'contract';
                this._tranProcessUriPath = 'contract';
                break;
            case 'ContractOption':
                this._tranCollectionUriPath = 'contract/{Contract_ID}/option';
                break;
            case 'Clearance':
                this._tranProcessUriPath = 'contract/clearance';
                break;
            case 'Application':
                this._tranGetUriPath = 'contract/application/{Proc_ID}';
                this._tranProcessUriPath = 'contract/application';
                break;
            case 'MarketSet':
                this._tranGetUriPath = 'contract/marketset/{ID}';
                this._tranProcessUriPath = 'contract/marketset';
                break;
            case 'Market':
                this._tranGetUriPath = 'contract/market/{Proc_ID}';
                this._tranProcessUriPath = 'contract/market';
                this._tranTemplateUriPath = 'contract/market/template';
                break;
            case 'Bind':
                this._tranGetUriPath = 'contract/bind/{Proc_ID}';
                this._tranProcessUriPath = 'contract/bind';
                this._tranTemplateUriPath = 'contract/bind/template';
                break;
            case 'Quote':
                this._tranGetUriPath = 'contract/quote/{Proc_ID}';
                this._tranProcessUriPath = 'contract/quote';
                this._tranTemplateUriPath = 'contract/quote/template';
                break;
            case 'QuoteSet':
                this._tranGetUriPath = 'contract/quoteset/{Quote_Set_ID}';
                this._tranProcessUriPath = 'contract/quoteset';
                break;
            case 'Issue':
                this._tranGetUriPath = 'contract/issue/{Proc_ID}';
                this._tranProcessUriPath = 'contract/issue';
                this._tranTemplateUriPath = 'contract/issue/template';
                break;
            case 'Endorsement':
                this._tranGetUriPath = 'contract/endorsement/{Proc_ID}';
                this._tranProcessUriPath = 'contract/endorsement';
                this._tranTemplateUriPath = 'contract/endorsement/template';
                break;
            case 'ScheduleCancel':
                this._tranGetUriPath = 'contract/cancel/schedule/{Proc_ID}';
                this._tranProcessUriPath = 'contract/cancel/schedule';
                this._tranTemplateUriPath = 'contract/cancel/schedule/template';
                break;
            case 'Cancel':
                this._tranGetUriPath = 'contract/cancel/{Proc_ID}';
                this._tranProcessUriPath = 'contract/cancel';
                this._tranTemplateUriPath = 'contract/cancel/template';
                break;
            case 'Reinstate':
                this._tranGetUriPath = 'contract/reinstate/{Proc_ID}';
                this._tranProcessUriPath = 'contract/reinstate';
                this._tranTemplateUriPath = 'contract/reinstate/template';
                break;
            case 'SelfAudit':
                this._tranGetUriPath = 'contract/selfaudit/{Proc_ID}';
                this._tranProcessUriPath = 'contract/selfaudit';
                this._tranTemplateUriPath = 'contract/selfaudit/template';
                break;
            case 'Audit':
                this._tranGetUriPath = 'contract/audit/{Proc_ID}';
                this._tranProcessUriPath = 'contract/audit';
                this._tranTemplateUriPath = 'contract/audit/template';
                break;
            case 'ExtendTerm':
                this._tranGetUriPath = 'contract/extendterm/{Proc_ID}';
                this._tranProcessUriPath = 'contract/extendterm';
                this._tranTemplateUriPath = 'contract/extendterm/template';
                break;
            case 'Renewal':
                this._tranGetUriPath = 'contract/renewal/{Proc_ID}';
                this._tranProcessUriPath = 'contract/renewal';
                this._tranTemplateUriPath = 'contract/renewal/template';
                break;
            case 'Reissue':
                this._tranGetUriPath = 'contract/reissue/{Proc_ID}';
                this._tranProcessUriPath = 'contract/reissue';
                this._tranTemplateUriPath = 'contract/reissue/template';
                break;
            case 'Rewrite':
                this._tranGetUriPath = 'contract/rewrite/{Proc_ID}';
                this._tranProcessUriPath = 'contract/rewrite';
                this._tranTemplateUriPath = 'contract/rewrite/template';
                break;
            case 'ContractDisable':
                this._tranGetUriPath = 'contract/disable/{Proc_ID}';
                this._tranProcessUriPath = 'contract/disable';
                this._tranTemplateUriPath = 'contract/disable/template';
                break;
            case 'ChangeConsumer':
                this._tranGetUriPath = 'contract/changeconsumer/{Proc_ID}';
                this._tranProcessUriPath = 'contract/changeconsumer';
                this._tranTemplateUriPath = 'contract/changeconsumer/template';
                break;
            case 'NonRenew':
                this._tranGetUriPath = 'contract/nonrenew/{Proc_ID}';
                this._tranProcessUriPath = 'contract/nonrenew';
                this._tranTemplateUriPath = 'contract/nonrenew/template';
                break;
            case 'ContractRate':
                this._tranGetUriPath = 'contract/rate/{Proc_ID}';
                this._tranProcessUriPath = 'contract/rate';
                this._tranTemplateUriPath = 'contract/rate/template';
                break;
            case 'Consumer':
                this._tranCollectionUriPath = 'consumer';
                this._tranGetUriPath = 'consumer/{Entity_ID}';
                this._tranTemplateUriPath = 'consumer/template';
                this._tranProcessUriPath = 'consumer';

                break;
            case 'Supplier':
                this._tranGetUriPath = 'supplier/{Entity_ID}';
                this._tranTemplateUriPath = 'supplier/template';
                this._tranCollectionUriPath = 'supplier';
                this._tranProcessUriPath = 'supplier';
                break;
            case 'Broker':
                this._tranGetUriPath = 'broker/{Entity_ID}';
                this._tranTemplateUriPath = 'broker/template';
                this._tranCollectionUriPath = 'broker';
                this._tranProcessUriPath = 'broker';
                break;
            case 'ThirdParty':
                this._tranGetUriPath = 'thirdparty/{Entity_ID}';
                this._tranTemplateUriPath = 'thirdparty/template';
                this._tranProcessUriPath = 'thirdparty';
                break;
            case 'Employee':
                this._tranGetUriPath = 'employee/{Entity_ID}';
                this._tranTemplateUriPath = 'employee/template';
                this._tranCollectionUriPath = 'employee';
                this._tranProcessUriPath = 'employee';
                break;
            case 'Provider':
                this._tranGetUriPath = 'provider/{Entity_ID}';
                this._tranTemplateUriPath = 'provider/template';
                this._tranCollectionUriPath = 'provider';
                this._tranProcessUriPath = 'provider';
                break;
            case 'TaxAuthority':
                this._tranGetUriPath = 'taxauthority/{Entity_ID}';
                this._tranTemplateUriPath = 'taxauthority/template';
                this._tranCollectionUriPath = 'taxauthority';
                this._tranProcessUriPath = 'taxauthority';
                break;
            case 'FinanceCompany':
                this._tranGetUriPath = 'financecompany/{Entity_ID}';
                this._tranTemplateUriPath = 'financecompany/template';
                this._tranCollectionUriPath = 'financecompany';
                this._tranProcessUriPath = 'financecompany';
                break;
            case 'Workgroup':
                this._tranCollectionUriPath = 'workgroup';
                break;
            case 'Entity':
                this._tranGetUriPath = 'entity/{Entity_ID}';
                this._tranCollectionUriPath = 'entity';
                break;
            case 'Task':
                this._tranGetUriPath = 'task/{Task_ID}';
                this._tranCollectionUriPath = 'task';
                this._tranProcessUriPath = 'task';
                break;
            case 'Project':
                this._tranGetUriPath = 'project/{Project_ID}';
                this._tranCollectionUriPath = 'project';
                this._tranProcessUriPath = 'project';
                break;
            case 'Document':
                this._tranGetUriPath = 'document/{Doc_ID}';
                this._tranCollectionUriPath = 'document';
                this._tranProcessUriPath = 'document';
                break;
            case 'BrokerNote':
                this._tranGetUriPath = 'broker/note/{Note_ID}';
                this._tranCollectionUriPath = 'broker/{Entity_ID}/note';
                this._tranProcessUriPath = 'broker/note';
                break;
            case 'SupplierNote':
                this._tranGetUriPath = 'supplier/note/{Note_ID}';
                this._tranCollectionUriPath = 'supplier/{Entity_ID}/note';
                this._tranProcessUriPath = 'supplier/note';
                break;
            case 'ConsumerNote':
                this._tranGetUriPath = 'consumer/note/{Note_ID}';
                this._tranCollectionUriPath = 'consumer/{Entity_ID}/note';
                this._tranProcessUriPath = 'Consumer/note';
                break;
            case 'TaxAuthorityNote':
                this._tranGetUriPath = 'taxauthority/note/{Note_ID}';
                this._tranCollectionUriPath = 'taxauthority/{Entity_ID}/note';
                this._tranProcessUriPath = 'taxauthority/note';
                break;
            case 'ProviderNote':
                this._tranGetUriPath = 'provider/note/{Note_ID}';
                this._tranCollectionUriPath = 'provider/{Entity_ID}/note';
                this._tranProcessUriPath = 'provider/note';
                break;
            case 'FinanceCompanyNote':
                this._tranGetUriPath = 'financecompany/note/{Note_ID}';
                this._tranCollectionUriPath = 'financecompany/{Entity_ID}/note';
                this._tranProcessUriPath = 'financecompany/note';
                break;
            case 'EmployeeNote':
                this._tranGetUriPath = 'employee/note/{Note_ID}';
                this._tranCollectionUriPath = 'employee/{Entity_ID}/note';
                this._tranProcessUriPath = 'employee/note';
                break;
            case 'ThirdPartyNote':
                this._tranGetUriPath = 'thirdparty/note/{Note_ID}';
                this._tranCollectionUriPath = 'thirdparty/{Entity_ID}/note';
                this._tranProcessUriPath = 'thirdparty/note';
                break;
            case 'ContractNote':
                this._tranGetUriPath = 'contract/note/{Note_ID}';
                this._tranCollectionUriPath = 'contract/{Contract_ID}/note';
                this._tranProcessUriPath = 'contract/note';
                break;
            case 'ContractSetNote':
                this._tranCollectionUriPath = 'contract/{Contract_ID}/set/note';
                this._objectType = 'ContractNote';
                break;
            case 'ContractSubNote':
                this._tranCollectionUriPath = 'contract/{Contract_ID}/sub/note';
                this._objectType = 'ContractNote';
                break;
            case 'ClaimNote':
                this._tranGetUriPath = 'claim/note/{Note_ID}';
                this._tranCollectionUriPath = 'claim/{Claim_ID}/note';
                this._tranProcessUriPath = 'claim/note';
                break;
            case 'Claim':
                this._tranGetUriPath = 'claim/{Claim_ID}';
                this._tranCollectionUriPath = 'claim';
                break;
            case 'CodeSet':
                this._tranGetUriPath = 'codeset/{Set_Code}';
                this._tranCollectionUriPath = 'codeset';
                break;
            case 'SystemInfo':
                this._tranGetUriPath = 'sysinfo';
                break;
            case 'DBQuery':
                this._tranGetUriPath = 'dbquery/{Procedure_Name}';
                this._tranCollectionUriPath = 'dbquery/{Procedure_Name}';
                break;
            case 'Favorite':
                this._tranCollectionUriPath = 'favorite';
                this._tranProcessUriPath = 'favorite';
                break;
            case 'StatusCheck':
                this._tranGetUriPath = 'statuscheck';
                break;
            case 'RecentItem':
                this._tranCollectionUriPath = 'recent';
                this._tranProcessUriPath = 'recent';
                break;
            case 'Permission':
                this._tranCollectionUriPath = 'permission';
                break;
            case 'CriteriaView':
                this._tranCollectionUriPath = 'criteriaview';
                break;
            case 'Authenticate':
                this._tranGetUriPath = 'authenticate';
                this._rootNode = 'ETMReply';
                break;
            case 'Password':
                this._tranProcessUriPath = 'password';
                this._rootNode = 'ETMReply';
                break;
            case 'Log':
                this._tranProcessUriPath = 'log';
                this._rootNode = 'ETMReply';
                break;
            case 'Invoice':
                this._tranGetUriPath = 'accounting/invoice/{Invoice_ID}';
                this._tranProcessUriPath = 'accounting/invoice';
                this._tranTemplateUriPath = 'accounting/invoice/template';
                break;
            case 'InvoiceDocument':
                this._tranProcessUriPath = 'accounting/invoice/document';
                break;
            case 'JournalEntry':
                this._tranGetUriPath = 'accounting/journalentry/{GLJ_Set_ID}';
                this._tranProcessUriPath = 'accounting/journalentry';
                this._tranTemplateUriPath = 'accounting/journalentry/template';
                break;
            case 'JournalEntryDocument':
                this._tranProcessUriPath = 'accounting/journalentry/document';
                break;
            case 'BalanceForward':
                this._tranGetUriPath = 'accounting/balanceforward/{GLJ_Set_ID}';
                this._tranProcessUriPath = 'accounting/balanceforward';
                this._tranTemplateUriPath = 'accounting/balanceforward/template';
                break;
            case 'BalanceForwardDocument':
                this._tranProcessUriPath = 'accounting/balanceforward/document';
                break;
            case 'Receipt':
                this._tranGetUriPath = 'accounting/receipt/{Receipt_ID}';
                this._tranProcessUriPath = 'accounting/receipt';
                this._tranTemplateUriPath = 'accounting/receipt/template';
                break;
            case 'ReceiptDocument':
                this._tranProcessUriPath = 'accounting/receipt/document';
                break;
            case 'Reconcile':
                this._tranGetUriPath = 'accounting/reconcile/{Recon_List_ID}';
                this._tranProcessUriPath = 'accounting/reconcile';
                this._tranTemplateUriPath = 'accounting/reconcile/template';
                break;
            case 'Lockbox':
                this._tranGetUriPath = 'accounting/lockbox/{Lockbox_Set_ID}';
                this._tranProcessUriPath = 'accounting/lockbox';
                break;
            case 'ReconcileDocument':
                this._tranProcessUriPath = 'accounting/reconcile/document';
                break;
            case 'Deposit':
                this._tranGetUriPath = 'accounting/deposit/{Deposit_ID}';
                this._tranProcessUriPath = 'accounting/deposit';
                this._tranTemplateUriPath = 'accounting/deposit/template';
                break;
            case 'DepositDocument':
                this._tranProcessUriPath = 'accounting/deposit/document';
                break;
            case 'Disbursement':
                this._tranGetUriPath = 'accounting/disbursement/{Disburse_ID}';
                this._tranProcessUriPath = 'accounting/disbursement';
                this._tranTemplateUriPath = 'accounting/disbursement/template';
                break;
            case 'BankRecon':
                this._tranGetUriPath = 'accounting/bankrecon/{BankRec_ID}';
                this._tranProcessUriPath = 'accounting/bankrecon';
                this._tranTemplateUriPath = 'accounting/bankrecon/template';
                break;
            case 'PeriodEnd':
                this._tranGetUriPath = 'accounting/periodend/{Period_End_ID}';
                this._tranProcessUriPath = 'accounting/periodend';
                this._tranTemplateUriPath = 'accounting/periodend/template';
                break;
            case 'PeriodEndDocument':
                this._tranProcessUriPath = 'accounting/periodend/document';
                break;
            case 'OffsetDeferred':
                this._tranProcessUriPath = 'accounting/offsetdeferred';
                this._tranTemplateUriPath = 'accounting/offsetdeferred/template';
                break;
            case 'Bill':
                this._tranGetUriPath = 'accounting/bill/{Bill_ID}';
                this._tranProcessUriPath = 'accounting/bill';
                this._tranTemplateUriPath = 'accounting/bill/template';
                break;
            case 'ThirteenthPeriodAdjustment':
                this._tranGetUriPath = 'accounting/thirteenthperiodadjustment/{GLJ_Set_ID}';
                this._tranProcessUriPath = 'accounting/thirteenthperiodadjustment';
                this._tranTemplateUriPath = 'accounting/thirteenthperiodadjustment/template';
                break;
            case 'ThirteenthPeriodAdjustmentDocument':
                this._tranProcessUriPath = 'accounting/thirteenthperiodadjustment/document';
                break;
            case 'Lockbox':
                this._tranGetUriPath = 'accounting/lockbox/{Lockbox_Set_ID}';
                this._tranProcessUriPath = 'accounting/lockbox';
                break;
            case 'PostingWizard':
                this._tranProcessUriPath = 'accounting/postingwizard';
                this._tranTemplateUriPath = 'accounting/postingwizard/template';
                break;
            case 'Correspond':
                this._tranGetUriPath = 'correspond/{Correspond_ID}';
                this._tranCollectionUriPath = 'correspond';
                this._tranProcessUriPath = 'correspond';
                break;
            case 'ProductLineConfig':
                this._tranGetUriPath = 'config/productline/{Line_Code}';
                break;
            case 'ReportPDFStream':
                this._tranGetUriPath = 'report/{Object_Code}.pdf';
                break;
            case 'Report':
                this._tranProcessUriPath = 'report/{Object_Code}';
                this._tranTemplateUriPath = 'report/{Object_Code}/template';
                break;
            case 'MergeDocument':
                this._tranProcessUriPath = 'mergedocument/{Object_Code}';
                this._tranTemplateUriPath = 'mergedocument/{Object_Code}/template';
                break;
            case 'InvoicePreview':
                this._tranGetUriPath = 'accounting/invoice/{Invoice_ID}/document.pdf';
                break;
            case 'ReceiptPreview':
                this._tranGetUriPath = 'accounting/receipt/{Receipt_ID}/document.pdf';
                break;
            case 'ReconcilePreview':
                this._tranGetUriPath = 'accounting/reconcile/{Recon_List_ID}/document.pdf';
                break;
            case 'DepositPreview':
                this._tranGetUriPath = 'accounting/deposit/{Deposit_ID}/document.pdf';
                break;
            case 'JournalEntryPreview':
                this._tranGetUriPath = 'accounting/journalentry/{GLJ_Set_ID}/document.pdf';
                break;
            case 'BalanceForwardPreview':
                this._tranGetUriPath = 'accounting/balanceforward/{GLJ_Set_ID}/document.pdf';
                break;
            case 'DisbursementPreview':
                this._tranGetUriPath = 'accounting/disbursement/{Disburse_ID}/document.pdf';
                break;
            case 'DisbursementDocument':
                this._tranProcessUriPath = 'accounting/disbursement/document';
                break;
            case 'BankReconPreview':
                this._tranGetUriPath = 'accounting/bankrecon/{BankRec_ID}/document.pdf';
                break;
            case 'PeriodEndPreview':
                this._tranGetUriPath = 'accounting/periodend/{Period_End_ID}/document.pdf';
                break;
            case 'ThirteenthPeriodAdjustmentPreview':
                this._tranGetUriPath = 'accounting/thirteenthperiodadjustment/{GLJ_Set_ID}/document.pdf';
                break;
            case 'DocGenerate':
                this._tranGetUriPath = 'document/generate/{Object_Code}.pdf';
                break;
            case 'ZipCode':
                this._tranGetUriPath = 'zipcode/{Zip_Code}';
                break;
            case 'VINLookup':
                this._tranCollectionUriPath = 'interface/vinlookup';
                break;
            case 'SanctionLookup':
                this._tranCollectionUriPath = 'interface/sanctionlookup';
                break;
            case 'EntitySanction':
                this._tranGetUriPath = 'interface/sanction';
                this._tranProcessUriPath = 'interface/sanction';
                break;
            case 'AddressLookup':
                this._tranCollectionUriPath = 'interface/addresslookup';
                break;
            case 'ContractDocument':
                this._tranProcessUriPath = 'contract/document';
                this._tranTemplateUriPath = 'contract/document/template';
                break;
            case 'DocumentAssembler':
                this._tranProcessUriPath = 'project/assembler';
                this._tranTemplateUriPath = 'project/assembler/template';
                break;
            case 'BrokerAgreementTerm':
                this._tranCollectionUriPath = 'broker/agreementterm';
                break;
            case 'SupplierAgreementTerm':
                this._tranCollectionUriPath = 'supplier/agreementterm';
                break;
            case 'Object':
                this._tranGetUriPath = 'object/{Object_Code}/{Object_ID}';
                break;
            case 'ObjectConfig':
                this._tranCollectionUriPath = 'config/object';
                break;
            case 'Menu':
                this._tranCollectionUriPath = 'menu';
                break;
            case 'ContractCondition':
                this._tranGetUriPath = 'contract/{Contract_ID}/condition';
                this._tranProcessUriPath = 'contract/condition';
                break;
            case 'Form':
                this._tranCollectionUriPath = 'form';
                break;
            case 'Condition':
                this._tranCollectionUriPath = 'condition';
                break;
            case 'Lock':
                this._tranProcessUriPath = 'lock';
                break;
            case 'ContractAffiliate':
                this._tranGetUriPath = 'contract/{Contract_ID}/affiliate';
                this._tranProcessUriPath = 'contract/affiliate';
                break;
            case 'Workspace':
                this._rootNode = 'ETMReply';
                this._tranGetUriPath = 'workspace/{Workspace_Key}/content';
                this._tranCollectionUriPath = 'workspace';
                this._tranProcessUriPath = 'workspace/{Workspace_Key}';
                break;
            case 'MenuConfig':
                this._tranCollectionUriPath = 'config/menu';
                this._tranGetUriPath = 'config/menu/{Menu_ID}';
                this._tranProcessUriPath = 'config/menu';
                break;
            case 'SpreadsheetRating':
                this._tranProcessUriPath = 'spreadsheetrating';
                break;
            case 'InstallmentSet':
                this._tranGetUriPath = 'accounting/installmentset/{Inst_Set_ID}';
                this._tranProcessUriPath = 'accounting/installmentset';
                break;
            case 'PageLayout':
                this._tranCollectionUriPath = 'pagelayout';
                break;
            case 'PageLayoutConfig':
                this._tranCollectionUriPath = 'config/pagelayout';
                this._tranGetUriPath = 'config/pagelayout/{Layout_Object_Code}';
                this._tranProcessUriPath = 'config/pagelayout';
                break;
            case 'PageLayoutOrderConfig':
                this._tranGetUriPath = 'config/pagelayout/order/{Parent_Object_Code}';
                this._tranProcessUriPath = 'config/pagelayout/order';
                break;
            case 'ComponentSettingConfig':
                this._tranCollectionUriPath = 'config/pagelayout/componentsetting';
                this._tranGetUriPath = 'config/pagelayout/componentsetting/{Setting_ID}';
                break;
            case 'IntegrationActionConfig':
                this._tranCollectionUriPath = 'config/integration/action';
                break;
            case 'IntegrationRequest':
                this._tranCollectionUriPath = 'config/integration/request';
                break;
            case 'IntegrationServiceConfig':
                this._tranGetUriPath = 'config/integration/service/{Service_ID}';
                this._tranCollectionUriPath = 'config/integration/service';
                this._tranProcessUriPath = 'config/integration/service';
                break;
            case 'UserDefinedProcedures':
                this._tranGetUriPath = 'userdefinedprocedures/{id}';
                this._tranCollectionUriPath = 'userdefinedprocedures';
                this._tranProcessUriPath = 'userdefinedprocedures';
                this._tranPatchUriPath = 'userdefinedprocedures/{id}';
                this._apiType = 'JSON';
                break;
            case 'UserDefinedTableConfig':
                this._tranGetUriPath = 'config/userdefinedtable/{Object_Code}';
                break;
            case 'UserOption':
                this._tranGetUriPath = 'useroption/{Entity_ID}';
                this._tranProcessUriPath = 'useroption';
                break;
            case 'Users':
                this._tranGetUriPath = 'users/{id}';
                this._tranCollectionUriPath = 'users';
                this._tranProcessUriPath = 'users';
                this._tranPatchUriPath = 'users/{id}';
                this._apiType = 'JSON';
                break;
            case 'Certificate':
                this._tranGetUriPath = 'contract/certificate/{Cert_ID}';
                this._tranProcessUriPath = 'contract/certificate';
                this._tranTemplateUriPath = 'contract/certificate/template';
                break;
            case 'CertificateDocument':
                this._tranProcessUriPath = 'contract/certificate/document';
                break;
            case 'CertificatePreview':
                this._tranGetUriPath = 'contract/certificate/{Cert_ID}/document.pdf';
                break;
            case 'Interface':
                this._tranGetUriPath = 'interface/app/{Object_Code}/{Interface_GUID}';
                this._tranProcessUriPath = 'interface/app/{Object_Code}';
                break;
            case 'CheckPrint':
                this._tranGetUriPath = '';
                this._tranProcessUriPath = 'accounting/checkprint';
                break;
            case 'CheckFoul':
                this._tranGetUriPath = '';
                this._tranProcessUriPath = 'accounting/checkfoul';
                this._tranTemplateUriPath = 'accounting/checkfoul/template';
                break;
            default:
                console.error('Unsupported Object Type: ' + value + ' (Note: Object type is case sensitive)');
                this._replyCode = -1;
                this._replyMessage = '';
                this.setStatus(DataSourceStatus.InvalidConfig);
        }
    }

    get(criteria?: any, retrieveNow: boolean = true, useCache: boolean = true) {
        //added 5/2/17
        if (criteria) {
            this.criteria = criteria;
        }
        this.datasourceService.get(this, this.criteria, retrieveNow, useCache);
    }

    getCollection(criteria?: any, retrieveNow: boolean = true, useCache: boolean = true) {
        //added 5/2/17
        if (criteria) {
            this.criteria = criteria;
        }
        this.datasourceService.getCollection(this, this.criteria, retrieveNow, useCache);
    }

    getTemplate(criteria?: any, retrieveNow: boolean = true) {
        if (criteria) {
            this.criteria = criteria;
        }
        this.datasourceService.getTemplate(this, this.criteria, retrieveNow);
    }

    process(criteria: any, body: any) {
        //added 5/2/17
        this.datasourceService.process(this, criteria, body);
    }

    patch(criteria: any, body: any) {
        this.datasourceService.patch(this, criteria, body);
    }

    refresh(useCache: boolean = true) {
        //added 5/2/17
        this.datasourceService.refresh(this, useCache);
    }

    reset() {
        //added 7/21/17
        this.datasourceService.reset(this);
    }

    startRefreshInterval(value: number) {
        this.datasourceService.startRefreshInterval(this, value); //added 5/2/17
    }

    setReplyCode(replyCode: number, replyMessage: string, forcedStatus?: DataSourceStatus) {
        //TODO: return errors for empty response, not ConceptOneReply, unexpected transaction, etc.
        if (replyCode >= 0) {
            if (this.data) {
                if (this.data[this._rootNode]) {
                    replyCode = this.data[this._rootNode]['Reply_Code'];
                    replyMessage = this.data[this._rootNode]['Process_Message'];
                    if (this.data[this._rootNode]['Process_Status'] == 'ERR') {
                        this._replyCode = replyCode;
                        this._replyMessage = replyMessage;
                        this.setStatus(DataSourceStatus.Error);
                    }

                    if (this.data[this._rootNode][this._tranType]) {
                        replyMessage = this.data[this._rootNode][this._tranType]['Process_Message'];
                    }
                }
            }
        }
        this._replyCode = replyCode;
        this._replyMessage = replyMessage;

        if (forcedStatus) {
            this.setStatus(forcedStatus);
        } else {
            // not an error then set status to ready!!!
            if (this._status != DataSourceStatus.Error) {
                this.setStatus(DataSourceStatus.Ready);
            }
        }
    }

    setMockData(data: any, criteria?: any) {
        let datevar = new Date(Date.now());
        let datestr: string =
            datevar.getFullYear() +
            '-' +
            ('0' + datevar.getMonth() + 1).slice(-2) +
            '-' +
            ('0' + datevar.getDate()).slice(-2) +
            'T' +
            ('0' + datevar.getHours()).slice(-2) +
            ':' +
            ('0' + datevar.getMinutes()).slice(-2) +
            ':' +
            ('0' + datevar.getSeconds()).slice(-2);

        //console.log(datestr);

        this.data = {
            '?xml': {
                '@version': '1.0'
            },
            ConceptOneReply: {
                '@Process_Status': 'PRC',
                '@Process_Message': 'Request successfully processed.',
                '@Reply_Code': '1',
                '@Process_Date': datestr,
                MockDataGet: {
                    '@Process_Status': 'PRC',
                    '@Process_Message': 'Transaction successfully processed.',
                    '@Reply_Code': '1',
                    MockData: data
                }
            }
        };
        if (criteria) {
            this.data.ConceptOneReply.MockDataGet.Criteria = criteria;
        }
        this._objectType = 'MockData';
        this._tranType = 'MockDataGet';
        this.setReplyCode(200, 'OK');
    }

    set refreshInterval(value: number) {
        this._refreshInterval = value;
    }

    get refreshInterval(): number {
        return this._refreshInterval;
    }

    set paused(value: boolean) {
        this._paused = value;
    }

    get paused(): boolean {
        return this._paused;
    }
}
